/**
 * Hook para gerenciar estilo do banner
 */

import { useMemo } from "react";
import type { EstablishmentPublic } from "../types";
import { buildEstablishmentBannerStyle } from "../../../lib/establishmentTheme";

export function useBannerStyle(establishment: EstablishmentPublic | null) {
  return useMemo(() => {
    return buildEstablishmentBannerStyle(establishment);
  }, [establishment]);
}
